<template>
  <div
    class="offcanvas offcanvas-end"
    id="OffcanvasForm"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ type === 'CREATE'? $t('Create Zone'): $t('Edit Zone')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="border-bottom mb-3 px-3 py-2">
        <i class="fa-solid fa-circle-info me-2" />
        {{ $t('Zone Information') }}
      </div>
      <div class="px-3">
        <div class="row g-3 py-2">
          <div class="col-12">
            <label for="supplier" class="form-label">
              {{ $t('Branch') }}
            </label>
            <div class="custom-input-group custom-input-group input-group input-group-sm">
              <select2
                style="width: 100%;"
                v-model="v$.form.branch_id.$model"
                :options="select2Branches.options"
                :settings="select2Branches.setting"
                :placeholder="$t('Select Branch') + '...'"
              />
              <div v-for="error of v$.form.branch_id.$errors"
                class="invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label
              for="name"
              class="form-label"
            >
              {{ $t('Zone Name') }}
              <span class="text-danger">*</span>
            </label>
            <div class="input-group-sm">
              <input
                id="name"
                type="text"
                v-model.trim="v$.form.name.$model"
                class="form-control shadow-none"
                :placeholder="$t('Enter zone name') + '...'"
              >
              <div v-for="error of v$.form.name.$errors"
                class="d-block invalid-feedback"
                :key="error.$uid"
              >
                {{ error.$message }}
              </div>
            </div>
          </div>
          <div class="col-12">
            <label for="note" class="form-label">
              {{ $t('Description') }}
            </label>
            <textarea
              class="form-control shadow-none"
              id="note"
              v-model.trim="v$.form.description.$model"
              style=" font-size: 14px;"
              :placeholder="$t('Optional description') + '...'"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission"
    >
      <ladda
        text="Save"
        v-if="type === 'CREATE'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleCreate"
      />
      <ladda
        text="Save"
        v-if="type === 'EDIT'"
        :btn-class="'btn btn-primary btn-block '"
        :loading="loadingSave"
        icon="<i class='fa-solid fa-floppy-disk'></i>"
        :disabled="v$.$invalid"
        @click="handleEdit"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light me-2 ms-2"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import AccessDenied from "@/plugins/AccessDenied.vue";
import Ladda from '@/plugins/Ladda.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import { Zones } from '@/services/endpoint/tables.service';
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validationConfig: {
    $lazy: true,
  },
  validations() {
    return validation(this.form)
  },
  props: {
    type: {
      type: String,
      default: 'CREATE'
    },
    id: {
      type: Number,
      default: 0
    },
  },
  data() {
    let vm = this;
    return {
      select2Branches: {
        options: [],
        setting: {
          minimumResultsForSearch: Infinity,
          allowClear: true
        }
      },
      loading: true,
      hasPermission: false,
      loadingSave: false,
      form: {
        name: '',
        code: ''
      }
    }
  },
  components: {
    PlaceholderContent,
    Ladda,
    AccessDenied,
    Select2
  },
  methods: {
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    async getCreateData() {
      await Zones.getCreate().then(res => {
        let vm = this;
        this.select2Branches.options = res.data.data.branches.map(function(item) {
          return {
            id: item.id,
            text: vm.$t(item.name)
          }
        });
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    async getUpdateData() {
      await Zones.getUpdate(this.id).then(res => {
        let vm = this;
        this.select2Branches.options = res.data.filter.branches.map(function(item) {
          return {
            id: item.id,
            text: vm.$t(item.name)
          }
        });
        this.form = {
          name: res.data.data.name,
          description: res.data.data.description,
          branch_id: res.data.data.branch_id
        };
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    setParamsBeforeSendCreate() {
      let params = _.cloneDeep(this.form);
      return $.each(params, (key, value) => {
        if (value === null || value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.cloneDeep(this.form);
      return $.each(params, (key, value) => {
        if (value === null || value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    async handleEdit() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Zones.update(this.id, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Update Zone!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
    async handleCreate() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Zones.create(this.setParamsBeforeSendCreate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Save Zone!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.message) {
          this.$toast.warn(err?.response?.data?.message);
        }
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        if (this.type === 'CREATE') await this.getCreateData();
        if (this.type === 'EDIT') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasFroms.open = false;
    });
  },
  computed: {
  }
}
</script>
